module.exports = __webpack_public_path__ + "static/img/brees-2019-slide-7.8844e5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2019-slide-7.jpg
// module id = KUtD
// module chunks = 1